import { createGlobalStyle } from 'styled-components';
import 'focus-visible';
import { KIOSK_SCALING_PERCENTAGE, UPPTACKA_KIOSK_SCALING_PERCENTAGE } from '../utils/constants';
const GuidaGlobalStyles = createGlobalStyle `
  ${props => props.$isKiosk &&
    `html {
    font-size:  ${props.$isUpptacka ? UPPTACKA_KIOSK_SCALING_PERCENTAGE : KIOSK_SCALING_PERCENTAGE}%;
  }`}
  body {
    font-family: "Noto IKEA", "notoIKEAlatin", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";   
  }

  .modal-header {
    h2 {
      margin: 0;
    }
  }

  .visually-hidden {
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
`;
export default GuidaGlobalStyles;
//# sourceMappingURL=GuidaGlobalStyles.js.map